import React from "react";

export const Button = ({ children, className, ...props }) => {
  return (
    <button
      className={`bg-green-500 text-white px-2 py-0.5 rounded text-xs mt-1 ml-2 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};